module.exports = __webpack_public_path__ + "img/142.once_a_month.e5c790c8.svg";